module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png",
      "alt": "LeadScorz",
      "title": "LeadScorz"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4"
  }, [_c('form', {
    staticClass: "ui form loginForm",
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [(!_vm.ok && !_vm.error) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("Please enter your new password.")]) : (_vm.ok) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Thank you! Please use your new password to "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Sign In")])], 1) : (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger text-left",
    attrs: {
      "role": "alert"
    }
  }, [_c('ul', _vm._l((_vm.error_msg), function(e) {
    return _c('li', [_vm._v(_vm._s(e))])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.ok) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password1",
      "placeholder": "New Password",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.ok) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password2",
      "placeholder": "Repeat New Password",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ok),
      expression: "!ok"
    }],
    staticClass: "btn btn-block btn-primary btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Go back to Sign In")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4720c612"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ResetPasswordConfirm.vue
// module id = 659
// module chunks = 0